import { TLocale } from '@internal/utils/machine/i18n/TLocale';

const formatters: Record<TLocale, Intl.NumberFormat> = {
    de: new Intl.NumberFormat('de', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    en: new Intl.NumberFormat('en', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    el: new Intl.NumberFormat('el', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    es: new Intl.NumberFormat('es', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    fr: new Intl.NumberFormat('fr', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    hu: new Intl.NumberFormat('hu', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    it: new Intl.NumberFormat('it', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    pl: new Intl.NumberFormat('pl', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    ro: new Intl.NumberFormat('ro', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    ru: new Intl.NumberFormat('ru', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    bg: new Intl.NumberFormat('bg', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    sl: new Intl.NumberFormat('sl', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    sr: new Intl.NumberFormat('bg', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    da: new Intl.NumberFormat('sl', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    cs: new Intl.NumberFormat('cs', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
    lt: new Intl.NumberFormat('lt', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }),
};

export const formatPrice = (locale: TLocale, value: number) => {
    if (!value) {
        return '';
    }
    return formatters[locale].format(value);
};
